import Inspector from './inspector';
const { InnerBlocks } = wp.blockEditor;

export default function Edit({ attributes, setAttributes }) {
  const { tabsHeading, margin, variant, containerized } = attributes;
  const ALLOWED_BLOCKS = ['app/tab-sumicity'];

  return (
    <div className={`TabSumicity ${margin} ${variant}`}>
      <div className={`${containerized ? 'Container' : ''}`}>
        <Inspector attributes={attributes} setAttributes={setAttributes} />
        {tabsHeading.length == 0 && (
          <>
            <div>
              <h3>Adicione uma nova guia no painel ao lado</h3>
              <p>1º - Informe o nome da guia</p>
              <p>2º - Informe o id da guia</p>
              <p>3º - Clique em registrar nova guia </p>
              <p class="warning">
                Obs: Adicione duas ou mais guias para selecionar os blocos para
                sua respectiva aba
              </p>
            </div>
          </>
        )}
        {tabsHeading.length > 0 && (
          <>
            <div className="TabSumicity__tabs">
              {tabsHeading.map((heading) => {
                if (!heading.title) return null;

                return (
                  <a id={heading.tabId} className="TabSumicity__tabs--title">
                    {heading.title}
                  </a>
                );
              })}
            </div>
            <InnerBlocks
              template={[['app/tab-sumicity']]}
              allowedBlocks={ALLOWED_BLOCKS}
            />
          </>
        )}
      </div>
    </div>
  );
}
